class FactoryTableInterface {
  constructor (dealType, realtyType) {
    this.dealType = dealType;
    this.realtyType = realtyType;
  }

  getHeaders () {
    return null;
  }

  getColumns () {
    return [];
  }
}

export default FactoryTableInterface;



// WEBPACK FOOTER //
// ./src/classes/builder/search/factories/factoryTableInterface.js